import merge from 'lodash/fp/merge'


const noMerge = key => ['info', 'responsibles', 'collaborators'].includes(key)
export default function entities(state = {}, action) {
  if (action.payload && action.payload.entities) {
    const entities = hackBug(action.payload.entities)
    const entries = Object.entries(entities)
    const reduce = entries
      .reduce((merged, [key, value]) => {
        return {
          ...merged,
          [key]: noMerge(key) ? merge({}, value) : merge(state[key], value)
        }
      }, state)

    return reduce
  }

  return state
}

const hackBug = entities => {
  if (!('collaborators' in entities)) {
    entities = { ...entities, ...{ collaborators: [] } }
  }
  if (!('info' in entities)) {
    entities = { ...entities, ...{ info: [] } }
  }

  return entities
}
